import { UserProfile } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { ProfilesAction, ProfilesActionTypes } from "./Profiles";
import { deleteFamilyProfile } from "@blacknut/javascript-sdk/dist/api/Family/FamilyProfile/deleteFamilyProfile";

export const dismissDeleteProfileError = () => {
  return (dispatch: Dispatch<ProfilesAction>) => {
    dispatch({ type: ProfilesActionTypes.DELETE_PROFILE_ERROR });
  };
};
export const deleteProfile = (uuid: string) => {
  return (dispatch: Dispatch<ProfilesAction>) => {
    return new Promise<UserProfile>((resolve, reject) => {
      dispatch({ type: ProfilesActionTypes.DELETE_PROFILE_REQUEST });
      deleteFamilyProfile(uuid).subscribe({
        next: (res) => {
          dispatch({ type: ProfilesActionTypes.DELETE_PROFILE_SUCCESS, uuid });
          resolve(res);
        },
        error: (error) => {
          dispatch({ type: ProfilesActionTypes.DELETE_PROFILE_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
